module.exports = __webpack_public_path__ + "static/media/eve-usdt.08a7dc76.svg";